/* MOB-001: one overlay/scroll-lock coordinator. Keeps a single active modal overlay,
   closes the previous one when a new one opens, and locks the body exactly once with
   iOS-safe scroll-position preservation (position:fixed + restored scrollTo). */
window.mpOverlay=(function(){
  var active=null, scrollY=0, locked=false;
  function lock(){ if(locked)return; scrollY=window.scrollY||window.pageYOffset||0; document.body.style.top=(-scrollY)+'px'; document.body.classList.add('has-modal-open'); locked=true; }
  function unlock(){ if(!locked)return; document.body.classList.remove('has-modal-open'); document.body.style.top=''; locked=false; window.scrollTo(0,scrollY); }
  return {
    open:function(key,closeFn){ if(active&&active.key!==key){ try{active.close();}catch(e){} } active={key:key,close:closeFn||function(){}}; lock(); },
    close:function(key){ if(active&&active.key===key){ active=null; unlock(); } else if(!active){ unlock(); } },
    isActive:function(key){ return !!active&&active.key===key; },
    activeKey:function(){ return active?active.key:null; }
  };
})();
/* pre-launch a11y: shared focus trap + restoration for modal overlays */
window.mpFocus=(function(){
  var SEL='a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  var handler=null,last=null,root=null;
  function visible(el){return el.offsetWidth>0||el.offsetHeight>0||el===document.activeElement;}
  function trap(container){
    release(false);
    last=document.activeElement; root=container;
    container.setAttribute('aria-modal','true');
    var f=Array.prototype.filter.call(container.querySelectorAll(SEL),visible);
    if(f.length){try{f[0].focus();}catch(e){}}
    handler=function(e){
      if(e.key!=='Tab'||!root)return;
      var nodes=Array.prototype.filter.call(root.querySelectorAll(SEL),visible);
      if(!nodes.length)return;
      var first=nodes[0],lastN=nodes[nodes.length-1];
      if(e.shiftKey&&document.activeElement===first){e.preventDefault();lastN.focus();}
      else if(!e.shiftKey&&document.activeElement===lastN){e.preventDefault();first.focus();}
      else if(!root.contains(document.activeElement)){e.preventDefault();first.focus();}
    };
    document.addEventListener('keydown',handler,true);
  }
  function release(restore){
    if(handler){document.removeEventListener('keydown',handler,true);handler=null;}
    if(root){root.removeAttribute('aria-modal');root=null;}
    if(restore!==false&&last&&last.focus){try{last.focus();}catch(e){}}
    last=null;
  }
  return {trap:trap,release:release};
})();
/* ===== consent gate: single source of truth for analytics permission (Shopify Customer Privacy) =====
   Fails closed — until the visitor has affirmatively allowed analytics, allowed() returns false, so no
   behavioral event, UTM storage or portal event beacon fires. Grant replays UTM capture; withdrawal
   clears stored attribution and, because every emitter re-checks allowed() at call time, stops future analytics. */
window.mpConsent=(function(){
  function read(){ try{ if(window.Shopify&&Shopify.customerPrivacy&&Shopify.customerPrivacy.analyticsProcessingAllowed){ return !!Shopify.customerPrivacy.analyticsProcessingAllowed(); } }catch(e){} return false; }
  var subs=[];
  function notify(){ var a=read(); subs.forEach(function(cb){ try{cb(a);}catch(e){} }); }
  function onChange(cb){ if(typeof cb==='function') subs.push(cb); }
  try{ if(window.Shopify&&Shopify.loadFeatures){ Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function(){ notify(); }); } }catch(e){}
  try{ document.addEventListener('visitorConsentCollected',notify); }catch(e){}
  return { allowed: read, onChange: onChange };
})();
  /* Reveal-on-scroll, refactored to a reusable, idempotent pass so it can run again for sections the
     Shopify editor inserts after initial load. */
  var mpIO = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); mpIO.unobserve(e.target); } }); }, {threshold:.12})
    : null;
  /* In the Shopify theme editor the page does not scroll naturally, so the scroll observer often never
     fires and content stays at its pre-reveal opacity (looks faded/washed-out vs the live page). In
     design mode we skip the animation and show everything at full opacity so the editor matches live. */
  var mpDesign = !!(window.Shopify && Shopify.designMode);
  window.mpReveal = function(root){
    var els = (root||document).querySelectorAll('.obs, .stagger');
    if(mpIO && !mpDesign){ els.forEach(function(el){ if(!el.classList.contains('in')) mpIO.observe(el); }); }
    else { els.forEach(function(el){ el.classList.add('in'); }); }
  };
  window.mpReveal(document);
  /* Theme-editor lifecycle: a section added or reordered in the editor is not scrolled through, so reveal
     its content immediately; other observed elements in it are (re)registered for normal scroll reveal. */
  document.addEventListener('shopify:section:load', function(e){
    var root = e.target || document;
    root.querySelectorAll('.obs, .stagger').forEach(function(el){ el.classList.add('in'); });
    window.mpReveal(root);
  });
  const burger=document.getElementById('burger'), panel=document.getElementById('mobilePanel');
  if(burger&&panel){
    const closeMobilePanel=()=>{burger.classList.remove('x');panel.classList.remove('open');burger.setAttribute('aria-expanded','false');window.mpOverlay.close('menu');window.mpFocus.release();};
    burger.addEventListener('click',()=>{const willOpen=!panel.classList.contains('open');burger.classList.toggle('x');panel.classList.toggle('open');burger.setAttribute('aria-expanded',panel.classList.contains('open'));if(willOpen){window.mpOverlay.open('menu',closeMobilePanel);window.mpFocus.trap(panel);}else{window.mpOverlay.close('menu');window.mpFocus.release();}});
    document.addEventListener('keydown',e=>{if(e.key==='Escape'&&panel.classList.contains('open')){closeMobilePanel();burger.focus();}});
    // MOB-003: if the viewport grows past the mobile breakpoint (rotate/resize) while the menu is open,
    // reset it so the page can never stay scroll-locked behind a hidden-but-open panel.
    var _mqDesktop=window.matchMedia('(min-width:1025px)');
    var _resetIfDesktop=function(){if(_mqDesktop.matches&&panel.classList.contains('open'))closeMobilePanel();};
    if(_mqDesktop.addEventListener){_mqDesktop.addEventListener('change',_resetIfDesktop);}else if(_mqDesktop.addListener){_mqDesktop.addListener(_resetIfDesktop);}
    // close the menu when a navigation link inside it is activated
    panel.addEventListener('click',function(e){if(e.target.closest('a[href]'))closeMobilePanel();});
    // MOB-016: accordion behaves as single-open, and the opened heading scrolls into view
    var _mpGroups=panel.querySelectorAll('details.mob-group');
    _mpGroups.forEach(function(d){
      d.addEventListener('toggle',function(){
        if(!d.open)return;
        _mpGroups.forEach(function(o){if(o!==d&&o.open)o.open=false;});
        var s=d.querySelector('summary');
        if(s){requestAnimationFrame(function(){s.scrollIntoView({behavior:'smooth',block:'nearest'});});}
      });
    });
  }
  // mega-menu triggers open via CSS (:hover/:focus-within); mirror that state into aria-expanded
  // so screen-reader users get the same open/closed signal sighted mouse users get from the caret.
  document.querySelectorAll('nav.main > .has-mega').forEach(function(group){
    const trigger=group.querySelector(':scope > [role="button"]');
    if(!trigger)return;
    const setOpen=v=>trigger.setAttribute('aria-expanded',v?'true':'false');
    group.addEventListener('mouseenter',()=>setOpen(true));
    group.addEventListener('mouseleave',()=>setOpen(false));
    group.addEventListener('focusin',()=>setOpen(true));
    group.addEventListener('focusout',e=>{if(!group.contains(e.relatedTarget))setOpen(false);});
    // keyboard: for pure dropdown triggers (no href), Enter/Space opens the panel and moves focus in
    trigger.addEventListener('keydown',function(e){
      if((e.key==='Enter'||e.key===' '||e.key==='Spacebar')&&!trigger.hasAttribute('href')){
        e.preventDefault();setOpen(true);
        var fl=group.querySelector('.mega a[href], .mega-panel a[href], .rail-panel a[href], .mega-col a[href]');
        if(fl){setTimeout(function(){try{fl.focus();}catch(x){}},10);}
      }
      if(e.key==='Escape'){setOpen(false);trigger.focus();}
    });
  });
  document.querySelectorAll('[data-video]').forEach(v=>{v.addEventListener('click',()=>{
    const src=(v.dataset.video||'').trim();
    if(!src){alert('▶ Video slot ready.\n\nAdd a YouTube or Vimeo URL in the theme editor for this section, and it will play here.');return;}
    let yt=src.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([\w-]{11})/);
    let vm=src.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    let embed='';
    if(yt){embed='https://www.youtube.com/embed/'+yt[1]+'?autoplay=1&rel=0';}
    else if(vm){embed='https://player.vimeo.com/video/'+vm[1]+'?autoplay=1';}
    if(embed){
      const f=document.createElement('iframe');
      f.src=embed;f.setAttribute('allow','autoplay; fullscreen; picture-in-picture');f.setAttribute('allowfullscreen','');
      f.style.cssText='position:absolute;inset:0;width:100%;height:100%;border:0;border-radius:inherit;z-index:6';
      v.style.position='relative';v.appendChild(f);
    } else if(/^https?:\/\//i.test(src)){
      const vid=document.createElement('video');
      vid.src=src;vid.controls=true;vid.autoplay=true;
      vid.style.cssText='position:absolute;inset:0;width:100%;height:100%;object-fit:cover;border-radius:inherit;z-index:6';
      v.style.position='relative';v.appendChild(vid);
    }
  });});

/* Torn-paper hero edge: match its fill to whatever section actually follows the hero,
   instead of assuming every hero sits on top of the default paper background. */
document.querySelectorAll('.hero-tear').forEach(function(tear){
  const heroWrap=tear.closest('.shopify-section')||tear.closest('section');
  if(!heroWrap) return;
  let next=heroWrap.nextElementSibling;
  while(next && next.tagName==='SCRIPT'){next=next.nextElementSibling;}
  if(!next) return;
  let probe=next;
  for(let i=0;i<4;i++){
    const bg=getComputedStyle(probe).backgroundColor;
    if(bg && bg!=='rgba(0, 0, 0, 0)' && bg!=='transparent'){tear.style.color=bg;return;}
    if(!probe.firstElementChild) break;
    probe=probe.firstElementChild;
  }
});


/* Our Story: sticky photo rail swaps to match whichever timeline entry is
   nearest the vertical center of the viewport as the visitor scrolls. */
(function(){
  const rail=document.querySelector('.os-rail');
  const items=document.querySelectorAll('.os-timeline .tl[data-key]');
  if(!rail || !items.length) return;
  const imgs=rail.querySelectorAll('.os-rail-img');
  const yrLabel=rail.querySelector('.os-rail-yr');
  const byKey={};
  imgs.forEach(img=>{byKey[img.dataset.key]=img;});
  const spy=new IntersectionObserver(entries=>{
    entries.forEach(entry=>{
      if(!entry.isIntersecting) return;
      const key=entry.target.dataset.key;
      const img=byKey[key];
      if(!img || img.classList.contains('active')) return;
      imgs.forEach(i=>i.classList.remove('active'));
      img.classList.add('active');
      if(yrLabel) yrLabel.textContent=key;
    });
  },{rootMargin:'-45% 0px -45% 0px',threshold:0});
  items.forEach(item=>spy.observe(item));
})();

/* ---- page-specific interactions (guarded; no-op when elements absent) ---- */

/* Filter chips (blog / case-studies hubs) */
const chips=document.querySelectorAll('.chip');let af='all';
function applyF(){const cards=document.querySelectorAll('.ccard[data-cat]');let vis=0;
cards.forEach(c=>{const m=(af==='all'||c.dataset.cat===af||(' '+(c.dataset.cats||'')+' ').indexOf(' '+af+' ')>-1);c.style.display=m?'':'none';if(m)vis++;});
const e=document.getElementById('empty');if(e)e.style.display=vis?'none':'block';}
chips.forEach(ch=>ch.addEventListener('click',()=>{chips.forEach(x=>x.classList.remove('on'));ch.classList.add('on');af=ch.dataset.f;applyF();}));

/* FAQ accordion (article templates) — accessible: aria-expanded + keyboard for non-button toggles */
document.querySelectorAll('.faq-q').forEach(function(q){
  q.setAttribute('aria-expanded', q.parentElement.classList.contains('open')?'true':'false');
  function toggle(){var open=q.parentElement.classList.toggle('open');q.setAttribute('aria-expanded',open?'true':'false');}
  q.addEventListener('click',toggle);
  if(q.tagName!=='BUTTON'){
    q.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '||e.key==='Spacebar'){e.preventDefault();toggle();}});
  }
});

/* Mega-menu rail: hover/focus a category to reveal its detail panel (click still navigates normally) */
document.querySelectorAll('[data-mega-rail]').forEach(rail=>{
  const items=rail.querySelectorAll('.rail-item');
  const panels=rail.querySelectorAll('.rail-panel');
  function activate(key){
    items.forEach(i=>i.classList.toggle('is-active',i.dataset.railTarget===key));
    panels.forEach(p=>p.classList.toggle('is-active',p.dataset.railPanel===key));
  }
  items.forEach(item=>{
    item.addEventListener('mouseenter',()=>activate(item.dataset.railTarget));
    item.addEventListener('focus',()=>activate(item.dataset.railTarget));
  });
});


/* ---- ROI / savings calculator (homepage; guarded — no-op when absent) ---- */
(function(){
  var area = document.getElementById('area');
  if(!area) return;  // not on this page
  var envSeg = document.getElementById('envSeg');
  var contSeg = document.getElementById('contSeg');
  var vArea = document.getElementById('vArea');
  var bigSave = document.getElementById('bigSave');
  var rMedia = document.getElementById('rMedia');
  var rCont = document.getElementById('rCont');
  var rWaste = document.getElementById('rWaste');
  var rTotal = document.getElementById('rTotal');

  // Illustrative per-m2 rates (calibrated to the worked example):
  var MEDIA_RATE = 9.5;   // abrasive media + supply, EUR/m2 at env factor 1
  var WASTE_RATE = 6.0;   // spent-grit collection + disposal, EUR/m2 at env factor 1
  // containment EUR/m2 comes from the selected button's data-c

  var envFactor = 1;      // data-f on the active environment button
  var contRate = 18;      // data-c on the active containment button

  function fmt(n){ return '\u20ac' + Math.round(n).toLocaleString('en-US'); }

  function recalc(){
    var a = parseFloat(area.value) || 0;
    var media = a * MEDIA_RATE * envFactor;
    var cont  = a * contRate   * envFactor;
    var waste = a * WASTE_RATE * envFactor;
    var total = media + cont + waste;
    if(vArea)   vArea.textContent = a;
    if(rMedia)  rMedia.textContent = fmt(media);
    if(rCont)   rCont.textContent  = fmt(cont);
    if(rWaste)  rWaste.textContent = fmt(waste);
    if(rTotal)  rTotal.textContent = fmt(total);
    if(bigSave) bigSave.textContent = Math.round(total).toLocaleString('en-US');
  }

  area.addEventListener('input', recalc);

  function wireSeg(seg, attr, set){
    if(!seg) return;
    seg.querySelectorAll('button').forEach(function(btn){
      btn.addEventListener('click', function(){
        seg.querySelectorAll('button').forEach(function(b){ b.classList.remove('on'); });
        btn.classList.add('on');
        set(parseFloat(btn.getAttribute(attr)));
        recalc();
      });
    });
  }
  wireSeg(envSeg,  'data-f', function(v){ envFactor = v; });
  wireSeg(contSeg, 'data-c', function(v){ contRate = v; });

  recalc();  // initial paint (no more zeros)
})();

/* ---- search overlay (guarded) ---- */
(function(){
  var openBtn = document.getElementById('searchOpen');
  var overlay = document.getElementById('searchOverlay');
  if(!openBtn || !overlay) return;
  var closeBtn = document.getElementById('searchClose');
  var input = document.getElementById('searchInput');
  function open(){
    overlay.classList.add('open');
    overlay.setAttribute('aria-hidden','false');
    window.mpOverlay.open('search',close);
    window.mpFocus.trap(overlay);
    if(input){ setTimeout(function(){ try{input.focus();}catch(e){} }, 60); }
  }
  function close(){
    overlay.classList.remove('open');
    overlay.setAttribute('aria-hidden','true');
    window.mpOverlay.close('search');
    var box=document.getElementById('searchResults');
    if(box){box.innerHTML='';box.hidden=true;}
    if(input){input.setAttribute('aria-expanded','false');}
    window.mpFocus.release();
  }
  openBtn.addEventListener('click', open);
  if(closeBtn) closeBtn.addEventListener('click', close);
  overlay.addEventListener('click', function(e){ if(e.target === overlay) close(); });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && overlay.classList.contains('open')) close(); });
})();

/* ===== Blast reveal: drag before/after ===== */
(function(){
  var reveal=document.getElementById('blastReveal');
  if(!reveal)return;
  var before=document.getElementById('revealBefore');
  var handle=document.getElementById('revealHandle');
  // swap in real images if data attributes provided
  function set(pct){
    pct=Math.max(0,Math.min(100,pct));
    before.style.width=pct+'%';
    handle.style.left=pct+'%';
    handle.setAttribute('aria-valuenow',Math.round(pct));
  }
  function pctFromEvent(clientX){
    var r=reveal.getBoundingClientRect();
    return ((clientX-r.left)/r.width)*100;
  }
  var dragging=false;
  function down(e){dragging=true;try{reveal.setPointerCapture(e.pointerId);}catch(_){}set(pctFromEvent(e.clientX));}
  function move(e){if(dragging)set(pctFromEvent(e.clientX));}
  function up(e){dragging=false;try{reveal.releasePointerCapture(e.pointerId);}catch(_){}}
  reveal.addEventListener('pointerdown',down);
  reveal.addEventListener('pointermove',move);
  reveal.addEventListener('pointerup',up);
  reveal.addEventListener('pointercancel',up);
  handle.addEventListener('keydown',function(e){
    var cur=parseFloat(handle.getAttribute('aria-valuenow'))||50;
    if(e.key==='ArrowLeft'){set(cur-5);e.preventDefault();}
    if(e.key==='ArrowRight'){set(cur+5);e.preventDefault();}
    if(e.key==='Home'){set(0);e.preventDefault();}
    if(e.key==='End'){set(100);e.preventDefault();}
  });
  // subtle auto-hint: nudge once when scrolled into view
  var hinted=false;
  var ro=new IntersectionObserver(function(es){es.forEach(function(en){
    if(en.isIntersecting&&!hinted){hinted=true;
      var p=50;var t=setInterval(function(){p-=1.5;set(p);if(p<=38){clearInterval(t);
        var t2=setInterval(function(){p+=1.5;set(p);if(p>=50){clearInterval(t2);set(50);}},16);}},16);
      ro.unobserve(en.target);}
  });},{threshold:.4});
  ro.observe(reveal);
  set(50);
})();

/* ===== Animated stat counters ===== */
(function(){
  var nums=document.querySelectorAll('.ec-stat b, .cas-stat b');
  if(!nums.length)return;
  function animate(el){
    var raw=el.textContent.trim();
    var m=raw.match(/^(\D*)(\d[\d,]*)(\D*)$/);
    if(!m){return;} // skip non-numeric like "1987" handled below or pure symbols
    var prefix=m[1],target=parseInt(m[2].replace(/,/g,''),10),suffix=m[3];
    if(isNaN(target))return;
    if(target>=1900&&target<=2100&&!suffix&&!prefix)return; // don't animate years like 1987
    var dur=1100,start=null;
    function step(ts){
      if(!start)start=ts;
      var p=Math.min((ts-start)/dur,1);
      var eased=1-Math.pow(1-p,3);
      var val=Math.round(target*eased);
      el.textContent=prefix+val.toLocaleString('en-US')+suffix;
      if(p<1)requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  var co=new IntersectionObserver(function(es){es.forEach(function(en){
    if(en.isIntersecting){animate(en.target);co.unobserve(en.target);}
  });},{threshold:.6});
  nums.forEach(function(n){co.observe(n);});
})();

/* ===== Contact intent picker → sets hidden enquiry_type + highlights ===== */
(function(){
  var intents=document.querySelectorAll('.intent[data-intent]');
  var field=document.getElementById('intentField');
  if(!intents.length)return;
  var tag=document.getElementById('formTag');
  var help=document.getElementById('helpSelect');
  function sync(val){
    if(field)field.value=val;
    if(tag)tag.textContent=val;
    if(help){for(var i=0;i<help.options.length;i++){if(help.options[i].value===val||help.options[i].text===val){help.selectedIndex=i;break;}}}
  }
  // set initial from the .on one
  var current=document.querySelector('.intent.on[data-intent]');
  if(current)sync(current.dataset.intent);
  // deep link: /pages/contact?topic=warranty|reorder|quote|demo|expert|distributor
  try{
    var topicMap={warranty:'Warranty / repair',reorder:'Spare parts / reorder',quote:'Request a Quote',demo:'Request a Demonstration',expert:'Talk with an Expert',distributor:'Become a distributor'};
    var tp=new URLSearchParams(location.search).get('topic');
    if(tp&&topicMap[tp]){
      var val=topicMap[tp];
      if(help){for(var i=0;i<help.options.length;i++){if(help.options[i].value===val){help.selectedIndex=i;break;}}}
      if(field)field.value=val;
      if(tag&&help)tag.textContent=help.options[help.selectedIndex].text;
      var card=document.querySelector('.intent[data-intent="'+val+'"]');
      if(card){intents.forEach(function(x){x.classList.remove('on');});card.classList.add('on');}
    }
  }catch(e){}
  intents.forEach(function(it){
    it.addEventListener('click',function(){
      intents.forEach(function(x){x.classList.remove('on');});
      it.classList.add('on');
      sync(it.dataset.intent);
      var form=document.querySelector('.cform, #contactForm');
      var first=document.querySelector('input[name="contact[first_name]"]');
      if(first){first.focus();first.scrollIntoView({behavior:'smooth',block:'center'});}
    });
  });
})();

/* ===== RFQ form: prefill "Product of interest" from ?product= deep link ===== */
(function(){
  var sel=document.querySelector('select[name="contact[product]"]');
  if(!sel)return;
  try{
    var productMap={'bristle-blaster':'Bristle Blaster®','mbx':'MBX®','vinyl-zapper':'Vinyl Zapper®','tercoo':'Tercoo®','robotics':'Robotics / Prepper®','decapower':'Decapower® (DIY)'};
    var pr=new URLSearchParams(location.search).get('product');
    if(pr&&productMap[pr]){
      var val=productMap[pr];
      for(var i=0;i<sel.options.length;i++){if(sel.options[i].text===val){sel.selectedIndex=i;break;}}
    }
  }catch(e){}
})();

/* ===== Lead context from content =====
   On an article: quote/contact links get ?product=<the article's product line>&from=<article path>, so the RFQ form
   pre-selects the product. On the quote/contact page: ?from= becomes hidden lead fields (product, lead_note) that
   MontiWise routes on (country + product line) and shows the rep ("Enquiry after reading …"). */
(function(){
  try{
    var el=document.getElementById('articleCtx');
    if(el){
      var c=JSON.parse(el.textContent||'{}');
      document.querySelectorAll('a[href*="/pages/rfq"],a[href*="/pages/contact"]').forEach(function(a){
        try{
          var u=new URL(a.getAttribute('href'),location.origin);
          if(u.origin!==location.origin)return;
          if(c.product&&!u.searchParams.get('product'))u.searchParams.set('product',c.product);
          if(c.from)u.searchParams.set('from',c.from);
          a.setAttribute('href',u.pathname+u.search+u.hash);
        }catch(e){}
      });
      try{sessionStorage.setItem('mp_from',JSON.stringify({from:c.from,title:c.title,line:c.line,industry:c.industry}));}catch(e){}
    }
    var q=new URLSearchParams(location.search), from=q.get('from'), ctx=null;
    try{ctx=JSON.parse(sessionStorage.getItem('mp_from')||'null');}catch(e){}
    if(!from&&!ctx)return;
    if(!/^\/blogs\/[a-z0-9-]+\/[^?#]+$/i.test(from||'')){if(!ctx)return;from=ctx.from;}
    var note='Enquiry after reading: '+((ctx&&ctx.from===from&&ctx.title)?ctx.title+' — ':'')+location.origin+from;
    document.querySelectorAll('form[data-hs-form]').forEach(function(f){
      var k=(f.getAttribute('data-hs-form')||'').toLowerCase();
      if(k==='newsletter'||k==='careers'||f.querySelector('input[name="lead_note"]'))return;
      var h=document.createElement('input');h.type='hidden';h.name='lead_note';h.value=note.slice(0,250);f.appendChild(h);
      if(ctx&&ctx.from===from&&ctx.line&&!f.querySelector('input[name="product"]')){var p=document.createElement('input');p.type='hidden';p.name='product';p.value=ctx.line;f.appendChild(p);}
    });
  }catch(e){}
})();

/* ===== Multi-product quote cart ===== */
(function(){
  /* Essential storage: the quote list itself (localStorage) is the visitor's own working cart and is not
     consent-gated. Quote-abandonment sync (MontiWise "Quote abandonment" tab): ONLY when the visitor has
     granted analytics consent, a snapshot of the list — and contact details typed into the quote form — is
     sent to MontiWise so the team can follow up on lists that are never sent. No consent → nothing is sent. */
  var KEY='mp_quote_v1', CID='mp_quote_cid';
  var QC_EP='https://montiwise.com/wp-json/mp/v1/web/quote-cart', _qcT=null, _qcLast='';
  function qcAllowed(){ try{ return !!window.__mpwiKey && !!(window.Shopify&&Shopify.customerPrivacy&&Shopify.customerPrivacy.analyticsProcessingAllowed&&Shopify.customerPrivacy.analyticsProcessingAllowed()); }catch(e){ return false; } }
  function qcCid(create){ try{ var c=localStorage.getItem(CID); if(!c&&create){ c=(Date.now().toString(36)+Math.random().toString(36).slice(2,12)).replace(/[^a-z0-9]/g,''); localStorage.setItem(CID,c); } return c||''; }catch(e){ return ''; } }
  function qcVid(){ try{ var m=document.cookie.match(/(?:^|; )mpwi_v=([^;]+)/); return m?decodeURIComponent(m[1]):''; }catch(e){ return ''; } }
  function qcForm(){ var f=document.querySelector('#quoteDrawer form'); if(!f) return {}; function v(sel){ var el=f.querySelector(sel); return el&&el.value?String(el.value).trim().slice(0,190):''; }
    return { email:v('input[type="email"]'), name:v('input[name="contact[name]"]'), company:v('input[name="contact[company]"]'), phone:v('input[type="tel"],input[name*="phone"]'), country:v('select[name*="country"],input[name*="country"]') }; }
  function qcSend(ev){
    if(!qcAllowed()) return;
    var list=load(), cid=qcCid(list.length>0||ev==='contact'); if(!cid) return;
    var fm=qcForm(), d={ k:window.__mpwiKey, cart:cid, v:qcVid(), ev:ev, u:location.href.slice(0,255), loc:((document.documentElement.lang||'').slice(0,5)),
      items:list.map(function(i){ return { title:decodeEnt(i.title), variant:decodeEnt(i.variantTitle||''), sku:decodeEnt(i.sku||''), handle:i.handle||'', qty:parseInt(i.qty,10)||1 }; }) };
    if(fm.email&&/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(fm.email)) d.email=fm.email;
    if(fm.name) d.name=fm.name; if(fm.company) d.company=fm.company; if(fm.phone) d.phone=fm.phone; if(fm.country) d.country=fm.country;
    var body=JSON.stringify(d); if(ev!=='submit'&&body===_qcLast) return; _qcLast=body;
    try{ if(navigator.sendBeacon) navigator.sendBeacon(QC_EP,new Blob([body],{type:'text/plain'})); else fetch(QC_EP,{method:'POST',body:body,keepalive:true,mode:'no-cors'}); }catch(e){}
  }
  function qcSoon(ev){ clearTimeout(_qcT); _qcT=setTimeout(function(){ qcSend(ev||'update'); },1500); }
  var fab=document.getElementById('quoteFab');
  var drawer=document.getElementById('quoteDrawer');
  if(!drawer)return;
  function esc(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}
  var _dec=document.createElement('textarea');
  function decodeEnt(s){ if(s==null)return ''; try{_dec.innerHTML=String(s);return _dec.value;}catch(e){return String(s);} } // turns a stored "MBX&reg;" back into "MBX®"
  var countEl=document.getElementById('quoteCount');
  var headCount=document.getElementById('quoteHeadCount');
  var itemsEl=document.getElementById('quoteItems');
  var emptyEl=document.getElementById('quoteEmpty');
  var footEl=document.getElementById('quoteFoot');
  var ctaBar=document.getElementById('quoteCtaBar');
  var ctaCount=document.getElementById('quoteCtaCount');
  var ctaBtn=document.getElementById('quoteContinue');
  var scrollEl=document.querySelector('#quoteDrawer .qd-scroll');
  var field=document.getElementById('quoteItemsField');
  // sticky CTA bar: jump to the details form; hide itself once the form is in view
  if(ctaBtn&&footEl&&scrollEl){
    ctaBtn.addEventListener('click',function(){
      footEl.scrollIntoView({behavior:'smooth',block:'start'});
      var f=footEl.querySelector('.qd-input,input,textarea,select');
      if(f)setTimeout(function(){try{f.focus({preventScroll:true});}catch(e){f.focus();}},320);
    });
    scrollEl.addEventListener('scroll',function(){
      if(ctaBar.hidden||!footEl||footEl.hidden)return;
      var ft=footEl.getBoundingClientRect().top, sb=scrollEl.getBoundingClientRect().bottom;
      ctaBar.classList.toggle('is-at-form', ft < sb - 40);
    },{passive:true});
  }

  // Treat any stored/attribute image URL as untrusted: cap length, allow only Shopify CDN or same-store
  // https(s) images (or a same-store relative path); reject javascript:/data:/arbitrary. Returns '' if invalid.
  function cleanImg(u){
    u=String(u==null?'':u).slice(0,300).trim();
    if(!u)return '';
    var rel=(u.charAt(0)==='/'&&u.charAt(1)!=='/');
    var test=rel?(location.origin+u):((u.slice(0,2)==='//')?('https:'+u):u);
    try{
      var url=new URL(test,location.origin);
      if(url.protocol!=='https:'&&url.protocol!=='http:')return '';
      if(!/\.(webp|jpe?g|png|gif|svg|avif)$/i.test(url.pathname))return ''; // must resolve to an image file
      if(rel)return u; // same-store relative path, extension validated
      var h=url.hostname.toLowerCase();
      if(h==='cdn.shopify.com'||h===location.hostname.toLowerCase()||/(^|\.)shopify\.com$/.test(h)||/(^|\.)shopifycdn\.com$/.test(h))return url.href;
    }catch(e){}
    return '';
  }
  function load(){try{var v=JSON.parse(localStorage.getItem(KEY));if(!Array.isArray(v))return [];return v.filter(function(i){return i&&typeof i==='object'&&i.id;}).slice(0,50).map(function(i){return {id:String(i.id).slice(0,80),title:String(i.title||'').slice(0,200),handle:String(i.handle||'').slice(0,120),sku:String(i.sku||'').slice(0,60),variant:String(i.variant||'').slice(0,40),variantTitle:String(i.variantTitle||'').slice(0,140),image:cleanImg(i.image),qty:Math.max(1,Math.min(999,parseInt(i.qty,10)||1))};});}catch(e){return [];}}
  function save(list){try{localStorage.setItem(KEY,JSON.stringify(list));}catch(e){} qcSoon(list.length?'update':'clear');}
  function totalQty(list){return list.reduce(function(s,i){return s+(parseInt(i.qty,10)||0);},0);}

  function render(){
    var list=load();
    if(countEl)countEl.textContent=totalQty(list);
    if(headCount)headCount.textContent=list.length?('('+list.length+')'):'';
    if(fab)fab.hidden=list.length===0 && !document.querySelector('.phero');
    if(list.length===0){
      if(emptyEl)emptyEl.style.display='';
      if(itemsEl)itemsEl.innerHTML='';
      if(footEl)footEl.hidden=true;
      if(ctaBar)ctaBar.hidden=true;
      return;
    }
    if(emptyEl)emptyEl.style.display='none';
    if(footEl)footEl.hidden=false;
    if(ctaBar){
      ctaBar.hidden=false;
      if(ctaCount)ctaCount.textContent=((window.themeI18n&&window.themeI18n.itemCount)||'__n__ items').replace('__n__',list.length);
    }
    itemsEl.innerHTML=list.map(function(it){
      var sid=esc(String(it.id)), st=esc(decodeEnt(it.title)), ssku=esc(decodeEnt(it.sku||'')), sq=parseInt(it.qty,10)||1;
      var svt=esc(decodeEnt(it.variantTitle||'')); if(svt==='Default Title')svt='';
      var sh=esc(it.handle||''), rawh=String(it.handle||'');
      // Curated cards (spare parts / belts) have no standalone product page — their id is prefixed
      // acc-/sp-/bp- and they carry the page handle "spare-parts" as a sentinel. Never link those,
      // or the title points at /products/spare-parts (404). Real products keep their linked title.
      var isCurated=/^(acc|sp|bp)-/.test(String(it.id))||rawh==='spare-parts';
      var ROOTq=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
      var titleHtml=(sh&&!isCurated)?('<a class="qd-item-link" href="'+ROOTq+'products/'+sh+'"><b>'+st+'</b></a>'):('<b>'+st+'</b>');
      var img=cleanImg(it.image);
      var media=img
        ? '<div class="qd-media"><img class="qd-thumb" src="'+esc(img)+'" width="64" height="64" loading="lazy" decoding="async" alt=""></div>'
        : '<div class="qd-media qd-media-ph" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" focusable="false"><path d="M3 16l5-5 4 4 3-3 6 6"/><rect x="3" y="4" width="18" height="16" rx="2"/><circle cx="8.5" cy="9" r="1.4"/></svg></div>';
      return '<div class="qd-item" data-id="'+sid+'">'+
        media+
        '<div class="qd-item-info">'+titleHtml+(svt?'<span class="qd-variant">'+svt+'</span>':'')+(ssku?'<span class="qd-sku">'+ssku+'</span>':'')+'</div>'+
        '<div class="qd-qty"><button type="button" class="qd-dec" aria-label="'+((window.themeI18n&&window.themeI18n.qtyDecrease)||'Decrease')+'">&minus;</button>'+
        '<span class="qd-q">'+sq+'</span>'+
        '<button type="button" class="qd-inc" aria-label="'+((window.themeI18n&&window.themeI18n.qtyIncrease)||'Increase')+'">+</button></div>'+
        '<button type="button" class="qd-remove" aria-label="'+((window.themeI18n&&window.themeI18n.qtyRemove)||'Remove')+'">&times;</button></div>';
    }).join('');
    // build hidden field text for submission (plain text, no HTML)
    if(field){
      field.value=list.map(function(it){var vt=(it.variantTitle&&it.variantTitle!=='Default Title')?' – '+decodeEnt(it.variantTitle):'';return (parseInt(it.qty,10)||1)+' x '+decodeEnt(it.title)+vt+(it.sku?' ('+decodeEnt(it.sku)+')':'');}).join('\n');
    }
  }

  function clean(s,max){return String(s==null?'':s).slice(0,max);}
  function add(item){
    var list=load();
    if(list.length>=50)return; // cap basket size
    var id=clean(item.id,80);
    var ex=list.filter(function(i){return i.id===id;})[0];
    if(ex){ex.qty=Math.min(999,ex.qty+1);}
    else{list.push({id:id,title:clean(item.title,200),handle:clean(item.handle,120),sku:clean(item.sku,60),variant:clean(item.variant,40),variantTitle:clean(item.variantTitle,140),image:cleanImg(item.image),qty:1});}
    save(list);render();openDrawer();
  }
  function changeQty(id,delta){
    var list=load();
    list.forEach(function(i){if(i.id===id)i.qty=Math.max(1,Math.min(999,i.qty+delta));});
    save(list);render();
  }
  function remove(id){
    var item=load().filter(function(i){return i.id===id;})[0];
    try{if(item&&window.mpTrack)window.mpTrack('quote_remove',{item_sku:item.sku||'',item_title:item.title||''});}catch(e){}
    save(load().filter(function(i){return i.id!==id;}));render();
    if(item&&typeof announce==='function')announce(((window.themeI18n&&window.themeI18n.removedFromQuoteSr)||'Removed from quote list:')+' '+item.title);
  }

  function openDrawer(){drawer.classList.add('open');drawer.setAttribute('aria-hidden','false');window.mpOverlay.open('quote',closeDrawer);var panel=drawer.querySelector('.qd-panel')||drawer;window.mpFocus.trap(panel);try{if(window.mpTrack)window.mpTrack('quote_open',{item_count:load().length});}catch(e){}}
  function closeDrawer(){drawer.classList.remove('open');drawer.setAttribute('aria-hidden','true');window.mpOverlay.close('quote');window.mpFocus.release();}

  // wire add-to-quote buttons
  function announce(msg){
    var live=document.getElementById('a11yStatus');
    if(!live)return;
    live.textContent='';
    setTimeout(function(){live.textContent=msg;},50); // reset first so repeat announcements aren't swallowed
  }
  // Resolve a product image for a quote line: explicit data-quote-image wins; otherwise fall back to the
  // originating product card's image (curated spare-part/belt cards) — scoped to a card so a non-product
  // enquiry never picks up an unrelated image.
  function imgFor(btn){
    var img=btn.dataset.quoteImage||'';
    if(!img){
      var card=btn.closest('.part, .ccard, .pcard, .p-card, .prod-card, [data-quote-card], .spare-card, .belt-card, article');
      var im=card&&card.querySelector('.p-img img, .p-photo, .pcard-img img, img');
      if(im)img=im.getAttribute('data-src')||im.currentSrc||im.src||'';
    }
    return img;
  }
  document.querySelectorAll('.js-add-to-quote').forEach(function(btn){
    btn.addEventListener('click',function(){
      add({id:btn.dataset.quoteId,title:btn.dataset.quoteTitle,handle:btn.dataset.quoteHandle,sku:btn.dataset.quoteSku,variant:btn.dataset.quoteVariant,variantTitle:btn.dataset.quoteVariantTitle,image:imgFor(btn)});
      var orig=btn.innerHTML;btn.innerHTML=(window.themeI18n&&window.themeI18n.added)||'Added \u2713';setTimeout(function(){btn.innerHTML=orig;},1200);
      announce(((window.themeI18n&&window.themeI18n.addedToQuoteSr)||'Added to quote list:')+' '+(btn.dataset.quoteTitle||''));
    });
  });
  // variant selector \u2192 keep the add-to-quote button in sync (id per variant so lines don't collide)
  document.querySelectorAll('.js-variant-select').forEach(function(sel){
    sel.addEventListener('change',function(){
      var opt=sel.options[sel.selectedIndex];
      var base=sel.getAttribute('data-base')||'';
      var btn=document.querySelector('.js-add-to-quote[data-quote-base="'+base+'"]');
      if(!btn||!opt)return;
      btn.dataset.quoteId=base+':'+sel.value;
      btn.dataset.quoteVariant=sel.value;
      btn.dataset.quoteSku=opt.getAttribute('data-sku')||'';
      btn.dataset.quoteVariantTitle=opt.getAttribute('data-title')||'';
      var vimg=opt.getAttribute('data-image');if(vimg)btn.dataset.quoteImage=vimg;
    });
  });
  if(fab)fab.addEventListener('click',openDrawer);
  var closeBtn=document.getElementById('quoteClose'),scrim=document.getElementById('quoteScrim');
  if(closeBtn)closeBtn.addEventListener('click',closeDrawer);
  if(scrim)scrim.addEventListener('click',closeDrawer);
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&drawer.classList.contains('open'))closeDrawer();});
  // delegate qty/remove
  if(itemsEl)itemsEl.addEventListener('click',function(e){
    var row=e.target.closest('.qd-item');if(!row)return;var id=row.dataset.id;
    if(e.target.classList.contains('qd-inc'))changeQty(id,1);
    else if(e.target.classList.contains('qd-dec'))changeQty(id,-1);
    else if(e.target.classList.contains('qd-remove'))remove(id);
  });
  // a broken thumbnail collapses to the neutral placeholder (no broken-image icon). error doesn't bubble → capture.
  if(itemsEl)itemsEl.addEventListener('error',function(e){
    var img=e.target;
    if(img&&img.classList&&img.classList.contains('qd-thumb')){
      var media=img.parentNode;
      if(media){media.classList.add('qd-media-ph');media.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" focusable="false"><path d="M3 16l5-5 4 4 3-3 6 6"/><rect x="3" y="4" width="18" height="16" rx="2"/><circle cx="8.5" cy="9" r="1.4"/></svg>';}
    }
  },true);
  // Before submit: refresh the hidden items field AND fold the product list into the message body.
  // Every downstream consumer (Shopify contact email, HubSpot "message", and the portal/Monti Wise
  // bridge) reads contact[body]; a standalone quote_items field is dropped unless each system has a
  // matching property — so the list must live in the body to be seen everywhere.
  var qform=footEl?footEl.querySelector('form'):null;
  // "Remember my details on this device": opt-in, stored ONLY in this browser's localStorage (no account,
  // no profile, never sent anywhere by this feature). The message/notes field is never stored.
  (function(){
    if(!qform) return;
    var RK='mp_contact_me', box=document.getElementById('qdRemember'), forget=document.getElementById('qdForget');
    function fields(){ return Array.prototype.filter.call(qform.querySelectorAll('input,select'),function(el){ var t=(el.type||'').toLowerCase(); return el.name!==undefined&&t!=='hidden'&&t!=='checkbox'&&t!=='submit'&&t!=='button'&&!/website_url|honeypot|quote_items|enquiry_type/.test(el.name||'')&&(el.name||el.id); }); }
    function keyOf(el){ return el.name||('#'+el.id); }
    function read(){ try{ var v=JSON.parse(localStorage.getItem(RK)||'null'); return v&&v.f?v:null; }catch(e){ return null; } }
    function store(){ var f={}; fields().forEach(function(el){ var v=String(el.value||'').trim(); if(v) f[keyOf(el)]=v.slice(0,200); }); try{ localStorage.setItem(RK,JSON.stringify({v:1,f:f,at:new Date().toISOString().slice(0,10)})); }catch(e){} if(forget) forget.hidden=false; }
    function wipe(clearFields){ try{ localStorage.removeItem(RK); }catch(e){} if(box) box.checked=false; if(forget) forget.hidden=true; if(clearFields) fields().forEach(function(el){ if(el.tagName==='SELECT'){ el.selectedIndex=0; } else el.value=''; }); }
    var saved=read();
    if(saved){
      fields().forEach(function(el){ var v=saved.f[keyOf(el)]; if(v!=null&&!el.value){ el.value=v; if(el.tagName==='SELECT'&&el.value!==v) el.selectedIndex=0; } });
      if(box) box.checked=true; if(forget) forget.hidden=false;
    }
    if(box) box.addEventListener('change',function(){ if(box.checked) store(); else wipe(false); });
    qform.addEventListener('change',function(e){ if(box&&box.checked&&e.target!==box) store(); });
    qform.addEventListener('submit',function(){ if(box&&box.checked) store(); },true);
    if(forget) forget.addEventListener('click',function(){ wipe(true); });
  })();
  // Required fields: replace the browser's bubble (it lands in the wrong spot inside the scrolling drawer)
  // with an inline message under the field, and scroll the first invalid field into view.
  if(qform){
    var _firstInvalid=null;
    qform.addEventListener('invalid',function(e){
      var el=e.target; e.preventDefault();
      el.classList.add('is-invalid'); el.setAttribute('aria-invalid','true');
      var id='err-'+(el.name||el.id||'f').replace(/[^a-z0-9]/gi,''), msg=document.getElementById(id);
      if(!msg){ msg=document.createElement('p'); msg.className='qd-field-err'; msg.id=id; msg.setAttribute('role','alert'); (el.closest('.phone-row')||el).insertAdjacentElement('afterend',msg); el.setAttribute('aria-describedby',id); }
      msg.textContent=el.validationMessage||'';
      if(!_firstInvalid){ _firstInvalid=el; setTimeout(function(){ try{ _firstInvalid.scrollIntoView({behavior:'smooth',block:'center'}); _firstInvalid.focus({preventScroll:true}); }catch(x){} _firstInvalid=null; },0); }
    },true);
    qform.addEventListener('input',clearErr,true); qform.addEventListener('change',clearErr,true);
    function clearErr(e){ var el=e.target; if(el&&el.classList&&el.classList.contains('is-invalid')&&el.checkValidity()){ el.classList.remove('is-invalid'); el.removeAttribute('aria-invalid'); var m=document.getElementById(el.getAttribute('aria-describedby')||''); if(m&&m.classList.contains('qd-field-err')) m.remove(); } }
  }
  // Contact details typed into the quote form are synced when a field is left (change), consent permitting.
  if(qform)qform.addEventListener('change',function(e){ var t=e.target; if(t&&/email|name|company|phone|tel|country/i.test((t.name||'')+' '+(t.type||''))) qcSoon('contact'); });
  if(qform)qform.addEventListener('submit',function(){
    render();
    clearTimeout(_qcT); qcSend('submit');
    var list=load();
    try{if(window.mpTrack)window.mpTrack('quote_submit',{item_count:list.length,skus:list.map(function(i){return i.sku||'';}).filter(Boolean).join(',')});}catch(e){}
    var bodyEl=qform.querySelector('textarea[name="contact[body]"]');
    if(bodyEl&&list.length&&bodyEl.dataset.mpItems!=='1'){
      var itemsText=list.map(function(it){
        var vt=(it.variantTitle&&it.variantTitle!=='Default Title')?' – '+decodeEnt(it.variantTitle):'';
        return '• '+(parseInt(it.qty,10)||1)+' x '+decodeEnt(it.title)+vt+(it.sku?' ('+decodeEnt(it.sku)+')':'');
      }).join('\n');
      var lbl=(window.themeI18n&&window.themeI18n.quoteItemsLabel)||'Requested products',
          nlbl=(window.themeI18n&&window.themeI18n.quoteNotesLabel)||'Notes',
          notes=bodyEl.value.trim();
      bodyEl.value=lbl+':\n'+itemsText+(notes?('\n\n'+nlbl+':\n'+notes):'');
      bodyEl.dataset.mpItems='1'; // survive the Shopify-fallback resubmit without double-prefixing
    }
    // Mark a quote submit in flight: if it goes through the native Shopify reload (no HubSpot GUID),
    // we re-surface the confirmation inside the drawer on the next page instead of scrolling away.
    try{sessionStorage.setItem('mp_quote_pending','1');}catch(e){}
  });

  // Inline confirmation inside the drawer — the visitor closes it themselves (no page scroll/close).
  function showQuoteSent(){
    if(emptyEl)emptyEl.style.display='none';
    if(itemsEl)itemsEl.innerHTML='';
    if(footEl)footEl.hidden=true;
    if(ctaBar)ctaBar.hidden=true;
    if(countEl)countEl.textContent='0';
    if(headCount)headCount.textContent='';
    var host=document.getElementById('quoteBody');
    if(host && !host.querySelector('.qd-sent')){
      var liq=footEl?footEl.querySelector('.qd-success'):null; // localized text Shopify already rendered
      var okTxt=(liq&&liq.textContent.trim())||(window.themeI18n&&window.themeI18n.quoteSuccess)||'Request sent — our team will be in touch shortly.';
      var closeTxt=(window.themeI18n&&window.themeI18n.quoteSentClose)||'You can close this panel whenever you’re ready.';
      var w=document.createElement('div');
      w.className='qd-sent'; w.setAttribute('role','status'); w.setAttribute('aria-live','polite'); w.setAttribute('tabindex','-1');
      w.innerHTML='<svg class="qd-sent-ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="9"/><path d="M8.5 12.5l2.4 2.4 4.6-5"/></svg>'+
        '<p class="qd-sent-msg">'+esc(okTxt)+'</p><span class="qd-sent-sub">'+esc(closeTxt)+'</span>';
      host.appendChild(w);
    }
    openDrawer();
    var f=host&&host.querySelector('.qd-sent');
    if(f)setTimeout(function(){try{f.focus({preventScroll:true});}catch(e){f.focus();}},350);
  }
  var _qpending=false; try{_qpending=sessionStorage.getItem('mp_quote_pending')==='1';}catch(e){}
  if(_qpending){
    try{sessionStorage.removeItem('mp_quote_pending');}catch(e){}
    var _ok=/[?&]contact_posted=true/.test(location.search)||(footEl&&footEl.querySelector('.qd-success'));
    var _err=footEl&&footEl.querySelector('.qd-error');
    if(_ok){ try{localStorage.removeItem(KEY);localStorage.removeItem(CID);}catch(e){} _qcLast=''; render(); showQuoteSent(); }
    else if(_err){ render(); if(footEl)footEl.hidden=false; openDrawer(); } // surface errors in-drawer
    else { render(); }
  } else { render(); }
})();

/* ===== Delegated card navigation (replaces inline onclick=location.href; CSP-safe + a11y) ===== */
(function(){
  var cards=document.querySelectorAll('[data-href]');
  if(!cards.length)return;
  cards.forEach(function(el){
    el.style.cursor='pointer';
    if(!el.hasAttribute('role'))el.setAttribute('role','link');
    if(!el.hasAttribute('tabindex'))el.setAttribute('tabindex','0');
    function go(){var u=el.getAttribute('data-href');if(u&&/^[\/a-zA-Z0-9]/.test(u)&&!/^javascript:/i.test(u))window.location.href=u;}
    el.addEventListener('click',go);
    el.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();go();}});
  });
})();

/* ===== Product info tabs: auto-split Body HTML at h3 into Overview/Specs/Documents/FAQ ===== */
(function(){
  var tabs=document.getElementById('productTabs');
  if(!tabs)return;
  var source=document.getElementById('productBody');
  var nav=document.getElementById('ptabsNav');
  var panels=document.getElementById('ptabsPanels');
  if(!source||!nav||!panels)return;
  function tabFor(h){
    h=h.toLowerCase();
    if(/document|datasheet|manual|download|drawing|brochure|leaflet|article list/.test(h)) return 'Documents';
    if(/faq|question|frequently/.test(h)) return 'FAQ';
    if(/overview|about|introduction|description|what is|how it works/.test(h)) return 'Overview';
    if(/feature|spec|highlight|belt|range|set|accessor|spare|part|technolog/.test(h)) return 'Specifications';
    return 'Specifications';
  }
  var nodes=Array.prototype.slice.call(source.childNodes);
  var buckets={'Overview':[]}, order=['Overview'], current='Overview';
  nodes.forEach(function(node){
    if(node.nodeType===1 && node.tagName==='H3'){
      var label=tabFor(node.textContent||'');
      current=label;
      if(!buckets[current]){buckets[current]=[];order.push(current);}
      // the tab button already labels the section — don't duplicate the divider heading inside the panel
    } else {
      buckets[current].push(node);
    }
  });
  if(order.length<=1) return; // nothing to split — leave as-is
  source.style.display='none';
  nav.setAttribute('role','tablist');
  var panelEls={}, btnEls={};
  var uid=(tabs.id||'ptabs')+'-'+Math.random().toString(36).slice(2,7);
  order.forEach(function(label,idx){
    var panelId=uid+'-panel-'+idx, tabId=uid+'-tab-'+idx;
    var p=document.createElement('div');
    p.className='ptab-panel rte'+(idx===0?' active':'');
    p.id=panelId;
    p.setAttribute('role','tabpanel');
    p.setAttribute('aria-labelledby',tabId);
    if(idx!==0)p.setAttribute('hidden','');
    buckets[label].forEach(function(n){p.appendChild(n.cloneNode(true));});
    panels.appendChild(p); panelEls[idx]=p;
    var b=document.createElement('button');
    b.type='button'; b.id=tabId; b.className='ptab-btn'+(idx===0?' active':''); b.setAttribute('role','tab');
    b.setAttribute('aria-selected',idx===0?'true':'false');
    b.setAttribute('aria-controls',panelId);
    b.setAttribute('tabindex',idx===0?'0':'-1');
    b.textContent=label;
    function activate(){
      nav.querySelectorAll('.ptab-btn').forEach(function(x){x.classList.remove('active');x.setAttribute('aria-selected','false');x.setAttribute('tabindex','-1');});
      panels.querySelectorAll('.ptab-panel').forEach(function(x){x.classList.remove('active');x.setAttribute('hidden','');});
      b.classList.add('active'); b.setAttribute('aria-selected','true'); b.setAttribute('tabindex','0');
      panelEls[idx].classList.add('active'); panelEls[idx].removeAttribute('hidden');
    }
    b.addEventListener('click',activate);
    b.addEventListener('keydown',function(e){
      var allBtns=Array.prototype.slice.call(nav.querySelectorAll('.ptab-btn'));
      var i=allBtns.indexOf(b), next=null;
      if(e.key==='ArrowRight')next=allBtns[(i+1)%allBtns.length];
      else if(e.key==='ArrowLeft')next=allBtns[(i-1+allBtns.length)%allBtns.length];
      else if(e.key==='Home')next=allBtns[0];
      else if(e.key==='End')next=allBtns[allBtns.length-1];
      if(next){e.preventDefault();next.focus();next.click();}
    });
    btnEls[idx]=b;
    nav.appendChild(b);
  });
})();

/* ===== Media-band before/after sliders (reusable; supports multiple per page) ===== */
(function(){
  var reveals=document.querySelectorAll('.mb-reveal');
  if(!reveals.length)return;
  reveals.forEach(function(reveal){
    var before=reveal.querySelector('.mb-before');
    var handle=reveal.querySelector('.mb-handle');
    if(!before||!handle)return;
    function set(pct){pct=Math.max(0,Math.min(100,pct));before.style.width=pct+'%';handle.style.left=pct+'%';handle.setAttribute('aria-valuenow',Math.round(pct));}
    function pctFrom(x){var r=reveal.getBoundingClientRect();return ((x-r.left)/r.width)*100;}
    var dragging=false;
    reveal.addEventListener('pointerdown',function(e){dragging=true;try{reveal.setPointerCapture(e.pointerId);}catch(_){}set(pctFrom(e.clientX));});
    reveal.addEventListener('pointermove',function(e){if(dragging)set(pctFrom(e.clientX));});
    reveal.addEventListener('pointerup',function(e){dragging=false;try{reveal.releasePointerCapture(e.pointerId);}catch(_){}});
    reveal.addEventListener('pointercancel',function(e){dragging=false;try{reveal.releasePointerCapture(e.pointerId);}catch(_){}});
    handle.addEventListener('keydown',function(e){var cur=parseFloat(handle.getAttribute('aria-valuenow'))||50;if(e.key==='ArrowLeft'){set(cur-5);e.preventDefault();}if(e.key==='ArrowRight'){set(cur+5);e.preventDefault();}if(e.key==='Home'){set(0);e.preventDefault();}if(e.key==='End'){set(100);e.preventDefault();}});
    set(50);
  });
})();

/* ===== UTM first-touch capture (consent-gated; consumed by HubSpot module) =====
   Attribution is analytics, so it is stored only once the visitor allows analytics. If they land with
   UTM params before consent, capture replays the moment consent is granted; withdrawal erases it. */
(function(){
  function capture(){
    if(!window.mpConsent||!window.mpConsent.allowed())return;
    try{
      var qs=new URLSearchParams(window.location.search);
      var utm={};
      ['utm_source','utm_medium','utm_campaign','utm_term','utm_content'].forEach(function(k){var v=qs.get(k);if(v)utm[k]=v.slice(0,200);});
      if(Object.keys(utm).length && !localStorage.getItem('mp_utm')){
        utm.first_landing_page=location.pathname;
        localStorage.setItem('mp_utm',JSON.stringify(utm));
      }
    }catch(e){}
  }
  capture();
  if(window.mpConsent){ window.mpConsent.onChange(function(a){ if(a){ capture(); } else { try{localStorage.removeItem('mp_utm');}catch(e){} } }); }
})();

/* ===== Lead-form flood guard =====
   Every lead form (data-hs-form except newsletter, and Shopify contact forms): at most N sends per browser in
   the time window (Theme settings → Spam protection), a hidden trap field bots fill, and a minimum time on the
   form. Runs in the window capture phase, before MontiWise forms.js and the HubSpot handler, so a blocked send reaches neither; the HubSpot fallback re-submit is not counted twice.
   Browser-side only (localStorage): it stops floods from one visitor, not direct posts to HubSpot. */
(function(){
  var el=document.getElementById('mpFormGuard');if(!el)return;
  var cfg={};try{cfg=JSON.parse(el.textContent);}catch(e){return;}
  var MAX=Math.max(1,+cfg.max||3),WIN=Math.max(1,+cfg.minutes||60)*60000,MIN=(cfg.min_seconds==null?3:+cfg.min_seconds)*1000,KEY='mp_form_log',mem=[];
  function load(){try{var a=JSON.parse(localStorage.getItem(KEY));return Array.isArray(a)?a:mem;}catch(e){return mem;}}
  function save(a){mem=a;try{localStorage.setItem(KEY,JSON.stringify(a));}catch(e){}}
  function lead(f){var k=f.getAttribute('data-hs-form');if(k)return k!=='newsletter';var t=f.querySelector('input[name="form_type"]');return !!(t&&t.value==='contact');}
  function track(r,f){try{if(window.mpTrack)window.mpTrack('form_error',{form_kind:f.getAttribute('data-hs-form')||'contact',reason:r});}catch(e){}}
  function say(f,txt){var m=f.querySelector('.mp-guard-msg');if(!m){m=document.createElement('p');m.className='mp-guard-msg form-error';m.setAttribute('role','alert');f.insertBefore(m,f.firstChild);}m.textContent=txt;try{m.scrollIntoView({block:'center'});}catch(e){}}
  var forms=[].slice.call(document.querySelectorAll('form')).filter(lead);
  forms.forEach(function(f){
    f.setAttribute('data-mp-t0',String(Date.now()));
    var hp=document.createElement('input');
    hp.type='text';hp.name='contact[mp_extra]';hp.tabIndex=-1;hp.autocomplete='off';hp.className='mp-hp';hp.setAttribute('aria-hidden','true');
    hp.style.cssText='position:absolute!important;left:-9999px!important;width:1px!important;height:1px!important;opacity:0!important';
    f.appendChild(hp);
  });
  // window capture = first in line: runs before MontiWise forms.js (document capture) and the HubSpot handler (form)
  window.addEventListener('submit',function(e){
    var f=e.target;
    if(!(f instanceof HTMLFormElement)||forms.indexOf(f)<0)return;
    if(f.getAttribute('data-hs-bypass')==='1')return; // HubSpot fallback re-submit: already counted
    if(!f.checkValidity())return;                       // let the form's own validation speak
    function stop(r,txt){e.preventDefault();e.stopImmediatePropagation();track(r,f);if(txt)say(f,txt);}
    var hp=f.querySelector('.mp-hp');
    if(hp&&hp.value)return stop('honeypot','');
    var now=Date.now();
    if(MIN&&now-(+f.getAttribute('data-mp-t0')||0)<MIN)return stop('too_fast',cfg.msg_fast||'');
    var log=load().filter(function(t){return now-t<WIN;});
    if(log.length>=MAX){var left=Math.max(1,Math.ceil((WIN-(now-log[0]))/60000));return stop('rate_limited',String(cfg.msg_limit||'').replace('%m',left));}
    log.push(now);save(log);
    var m=f.querySelector('.mp-guard-msg');if(m)m.remove();
  },true);
})();

/* ===== HubSpot lead capture =====
   Forms tagged data-hs-form="rfq|question|quote|distributor|contact|newsletter" submit to the
   HubSpot Forms API when #hsConfig (Theme settings → Lead capture) provides a portal ID + GUID.
   Inputs are mapped via data-hs-name; "firstname_lastname" splits a single Name field.
   On any error the form falls back to its native Shopify submission. */
(function(){
  var cfgEl=document.getElementById('hsConfig');
  if(!cfgEl)return;
  var cfg={};try{cfg=JSON.parse(cfgEl.textContent);}catch(e){return;}
  /* Inquiry auto-reply: after an inquiry form is sent, ask the ack worker to email the visitor a
     "thank you, our local team will contact you" message (Resend). Newsletter, event, webinar and
     careers forms are skipped; the worker enforces the same list plus rate limits. */
  var ACK_SKIP={newsletter:1,event:1,webinar:1,careers:1};
  function ackFrom(form,key){
    try{
      if(!cfg.ackUrl||ACK_SKIP[key])return;
      var em=form.querySelector('[data-hs-name="email"],input[type="email"]');
      var nm=form.querySelector('[data-hs-name="firstname_lastname"],[data-hs-name="firstname"],input[name="contact[name]"],input[autocomplete="name"]');
      window.mpInquiryAck({email:em&&em.value,name:nm&&nm.value,form:key});
    }catch(e){}
  }
  window.mpInquiryAck=function(d){
    try{
      if(!cfg.ackUrl||!d||!d.email||ACK_SKIP[d.form])return;
      fetch(cfg.ackUrl,{method:'POST',mode:'cors',keepalive:true,headers:{'Content-Type':'application/json'},
        body:JSON.stringify({email:String(d.email).trim(),name:d.name||'',form:d.form||'contact',locale:(document.documentElement.lang||'en'),page:location.pathname})}).catch(function(){});
    }catch(e){}
  };
  if(!cfg.portalId||!cfg.forms){
    document.querySelectorAll('form[data-hs-form]').forEach(function(f){f.addEventListener('submit',function(){if(f.checkValidity())ackFrom(f,f.getAttribute('data-hs-form'));});});
    return;
  }
  function hutk(){var m=document.cookie.match(/(?:^|;\s*)hubspotutk=([^;]+)/);return m?m[1]:undefined;}
  function utmFields(){try{return JSON.parse(localStorage.getItem('mp_utm'))||{};}catch(e){return{};}}
  document.querySelectorAll('form[data-hs-form]').forEach(function(form){
    var key=form.getAttribute('data-hs-form');
    var guid=form.getAttribute('data-hs-guid')||cfg.forms[key]; // per-page GUID override wins
    if(!guid){form.addEventListener('submit',function(){if(form.checkValidity())ackFrom(form,key);});return;}
    form.addEventListener('submit',function(e){
      if(form.getAttribute('data-hs-bypass')==='1')return; // fallback path
      e.preventDefault();
      if(!form.checkValidity()){form.reportValidity();try{if(window.mpTrack)window.mpTrack('form_error',{form_kind:key,reason:'validation'});}catch(e){}return;}
      var fields=[],seen={};
      function push(name,value){
        if(!name||value==null||value==='')return;
        if(seen[name])return;seen[name]=1;
        fields.push({objectTypeId:'0-1',name:name,value:String(value).slice(0,3000)});
      }
      form.querySelectorAll('[data-hs-name]').forEach(function(el){
        var hsName=el.getAttribute('data-hs-name');
        var val=(el.type==='checkbox')?(el.checked?'true':'false'):el.value;
        if(hsName==='firstname_lastname'){
          var parts=String(val).trim().split(/\s+/);
          push('firstname',parts.shift()||'');
          push('lastname',parts.join(' ')||'-');
        }else{
          push(hsName,val);
        }
      });
      if(window.mpConsent&&window.mpConsent.allowed()){
        var utm=utmFields();
        Object.keys(utm).forEach(function(k){push(k,utm[k]);});
      }
      push('locale',(document.documentElement.lang||'en'));
      var body={fields:fields,context:{pageUri:location.href,pageName:document.title}};
      var tok=hutk();if(tok)body.context.hutk=tok;
      var btn=form.querySelector('[type="submit"]');
      if(btn)btn.disabled=true;
      fetch('https://api.hsforms.com/submissions/v3/integration/submit/'+encodeURIComponent(cfg.portalId)+'/'+encodeURIComponent(guid),{
        method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)
      }).then(function(r){
        if(!r.ok)throw new Error('hs '+r.status);
        ackFrom(form,key);
        var camp=form.querySelector('.campaign-success');
        if(camp){
          // campaign forms carry a server-rendered rich success block (calendar / venue / replay)
          var flds=form.querySelector('.campaign-fields'); if(flds)flds.hidden=true;
          camp.hidden=false; try{camp.focus();camp.scrollIntoView({block:'center'});}catch(e){}
        }else{
          var msg=document.createElement('p');
          msg.className='nl-success hs-success';
          msg.setAttribute('role','status');
          msg.setAttribute('aria-live','polite');
          msg.setAttribute('tabindex','-1');
          msg.textContent=form.getAttribute('data-hs-success')||'Thank you — received. A specialist will be in touch shortly.';
          form.parentNode.insertBefore(msg,form);
          form.hidden=true;
          msg.focus();
        }
        try{if(window.mpConsent&&window.mpConsent.allowed()){if(window.mpTrack){window.mpTrack('lead_submit',{lead_form:key});}else if(window.dataLayer){window.dataLayer.push({event:'lead_submit',lead_form:key});}}}catch(e){}
        if(key==='quote'){try{localStorage.removeItem('mp_quote_v1');localStorage.removeItem('mp_quote_cid');}catch(e){}try{sessionStorage.removeItem('mp_quote_pending');}catch(e){}}
      }).catch(function(){
        try{if(window.mpTrack)window.mpTrack('form_error',{form_kind:key,reason:'submit_failed'});}catch(e){}
        if(btn)btn.disabled=false;
        ackFrom(form,key);
        form.setAttribute('data-hs-bypass','1');
        if(typeof form.requestSubmit==='function'){form.requestSubmit();}
        else{HTMLFormElement.prototype.submit.call(form);}
      });
    });
  });
  // contact page: keep the visible "What can we help with?" select in sync with the hidden intent field
  var help=document.getElementById('helpSelect'),intentF=document.getElementById('intentField');
  if(help&&intentF)help.addEventListener('change',function(){intentF.value=help.value;});
})();

/* ===== Region suggestion banner (separate-store architecture) ===== */
(function(){
  var banner=document.getElementById('regionBanner');
  var dataEl=document.getElementById('regionBannerData');
  if(!banner||!dataEl)return;
  try{
    if(localStorage.getItem('mp_region_dismiss'))return;
    var rules=JSON.parse(dataEl.textContent);
    var langs=(navigator.languages&&navigator.languages.length?navigator.languages:[navigator.language||'']).map(function(l){return String(l).toLowerCase();});
    var match=null;
    rules.some(function(r){
      var pref=String(r.lang||'').toLowerCase();
      if(!pref)return false;
      if(langs.some(function(l){return l===pref||l.indexOf(pref+'-')===0;})){match=r;return true;}
      return false;
    });
    if(!match)return;
    // don't suggest the site we're already on
    if(match.url&&location.hostname&&match.url.indexOf(location.hostname)>-1)return;
    document.getElementById('rbMsg').textContent=match.msg;
    var cta=document.getElementById('rbCta');
    cta.textContent=match.cta;cta.href=match.url;
    banner.hidden=false;
    document.getElementById('rbClose').addEventListener('click',function(){
      banner.hidden=true;
      try{localStorage.setItem('mp_region_dismiss','1');}catch(e){}
    });
  }catch(e){}
})();

/* ===== Predictive search (Shopify suggest API) ===== */
(function(){
  var input=document.getElementById('searchInput');
  var box=document.getElementById('searchResults');
  if(!input||!box)return;
  var labels={
    products:box.getAttribute('data-l-products')||'Products',
    pages:box.getAttribute('data-l-pages')||'Pages',
    articles:box.getAttribute('data-l-articles')||'Articles',
    none:box.getAttribute('data-l-none')||'No results found.',
    all:box.getAttribute('data-l-all')||'View all results',
    loading:box.getAttribute('data-l-loading')||'Searching…',
    error:box.getAttribute('data-l-error')||'Search is unavailable right now. Please try again.',
    count:box.getAttribute('data-l-count')||'__n__ results'
  };
  function esc(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}
  function setExpanded(v){input.setAttribute('aria-expanded',v?'true':'false');}
  function statusLine(msg){return '<span class="sr-only" role="status">'+esc(msg)+'</span>';}
  var timer=null,lastQ='',ctrl=null;
  input.addEventListener('input',function(){
    clearTimeout(timer);
    var q=input.value.trim();
    if(q.length<2){box.innerHTML='';box.hidden=true;setExpanded(false);lastQ='';if(ctrl){ctrl.abort();ctrl=null;}return;}
    timer=setTimeout(function(){
      if(q===lastQ)return;lastQ=q;
      var ROOT=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
      if(ctrl){ctrl.abort();}
      ctrl=('AbortController' in window)?new AbortController():null;
      box.innerHTML='<div class="psr-group psr-loading" role="status">'+esc(labels.loading)+'</div>';box.hidden=false;setExpanded(true);
      fetch(ROOT+'search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product,page,article&resources[limit]=4&resources[options][unavailable_products]=last',ctrl?{signal:ctrl.signal}:undefined)
        .then(function(r){return r.json();})
        .then(function(d){
          var res=(d&&d.resources&&d.resources.results)||{};
          var html='';
          function group(items,label){
            if(!items||!items.length)return;
            html+='<div class="psr-group"><span class="psr-label">'+esc(label)+'</span>';
            items.forEach(function(it){
              html+='<a class="psr-item" href="'+esc(it.url)+'"><b>'+esc(it.title)+'</b></a>';
            });
            html+='</div>';
          }
          group(res.products,labels.products);
          group(res.pages,labels.pages);
          group(res.articles,labels.articles);
          var total=((res.products||[]).length)+((res.pages||[]).length)+((res.articles||[]).length);
          var announce=total?labels.count.replace('__n__',total):labels.none;
          if(!html){html='<div class="psr-group"><span class="psr-label">'+esc(labels.none)+'</span></div>';}
          html+='<a class="psr-all" href="'+ROOT+'search?q='+encodeURIComponent(q)+'">'+esc(labels.all)+' &rarr;</a>';
          box.innerHTML=statusLine(announce)+html;box.hidden=false;setExpanded(true);
        }).catch(function(err){
          if(err&&err.name==='AbortError')return;
          box.innerHTML='<div class="psr-group psr-error" role="status">'+esc(labels.error)+'</div>';box.hidden=false;setExpanded(true);
        });
    },250);
  });
})();

/* Experience-center: 3D tilt on the product gallery main image */
(function(){
  if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var main=document.querySelector('.pgal-main');
  if(!main) return;
  var MAX=6;
  main.addEventListener('mousemove',function(e){
    var r=main.getBoundingClientRect();
    var px=(e.clientX-r.left)/r.width-0.5, py=(e.clientY-r.top)/r.height-0.5;
    main.classList.add('tilt');
    main.style.transform='perspective(1000px) rotateY('+(px*MAX).toFixed(2)+'deg) rotateX('+(-py*MAX).toFixed(2)+'deg)';
  });
  main.addEventListener('mouseleave',function(){
    main.classList.remove('tilt');
    main.style.transform='';
  });
})();

/* === conversion playbook layer: WhatsApp send, GA4 events, portal lead bridge === */
(function(){
  var cfgEl=document.getElementById('leadConfig'); if(!cfgEl) return;
  var cfg={}; try{cfg=JSON.parse(cfgEl.textContent)}catch(e){return}
  /* central tracker: GA4 dataLayer + optional portal event beacon (dormant until configured).
     Consent-gated at the single choke point — no behavioral dataLayer event or portal event request
     leaves the page unless analytics consent is currently allowed (re-checked every call). */
  window.mpTrack=function(ev,params){
    if(!window.mpConsent||!window.mpConsent.allowed()) return;
    try{ window.dataLayer=window.dataLayer||[]; window.dataLayer.push(Object.assign({event:ev},params||{})); }catch(e){}
    try{
      if(!cfg.events||!cfg.eventsKey) return;
      var payload=JSON.stringify({event:ev,params:params||{},url:location.pathname,ref:document.referrer||'',loc:document.documentElement.lang||'en',ts:Date.now()});
      var u=cfg.events+'?k='+encodeURIComponent(cfg.eventsKey);
      if(navigator.sendBeacon){navigator.sendBeacon(u,new Blob([payload],{type:'application/json'}));}
      else{fetch(u,{method:'POST',keepalive:true,headers:{'Content-Type':'application/json'},body:payload}).catch(function(){});}
    }catch(e){}
  };
  function ga(ev,params){ window.mpTrack(ev,params); }
  /* distributor + outbound + language + intent instrumentation */
  document.addEventListener('click',function(e){
    var card=e.target.closest('.dist-card');
    var dname=card?((card.querySelector('.dist-name')||{}).textContent||'').trim():'';
    var dc=e.target.closest('a.dist-contact');
    if(dc){
      var href=dc.getAttribute('href')||'';
      var method=href.indexOf('tel:')===0?'phone':(href.indexOf('mailto:')===0?'email':'website');
      ga('distributor_click',{method:method,distributor:dname,link_url:href});
      return;
    }
    var ds=e.target.closest('.dist-socials a');
    if(ds){ ga('distributor_social',{network:ds.getAttribute('aria-label')||'',distributor:dname,link_url:ds.href||''}); return; }
    var dm=e.target.closest('.js-dist-contact');
    if(dm){ ga('distributor_contact_open',{distributor:dm.getAttribute('data-dist-name')||dname}); return; }
    var lb=e.target.closest('.lang-menu button[name="locale_code"]');
    if(lb){ ga('language_switch',{to:lb.value||''}); return; }
    var it=e.target.closest('.intent[data-intent]');
    if(it){ ga('contact_intent',{intent:it.dataset.intent||''}); return; }
    var a=e.target.closest('a[href^="http"]');
    if(a){
      try{
        var host=new URL(a.href).hostname.replace(/^www\./,'');
        var here=location.hostname.replace(/^www\./,'');
        if(host!==here && host.indexOf('montipower.com')===-1 && host!=='wa.me' && host.indexOf('whatsapp.com')===-1 && host!=='cdn.shopify.com'){
          ga('outbound_click',{domain:host,link_text:(a.textContent||'').trim().slice(0,80),link_url:a.href});
        }
      }catch(err){}
    }
  },true);
  /* GA: whatsapp clicks (float + any [data-ga=whatsapp_click]) */
  document.addEventListener('click',function(e){
    var a=e.target.closest('[data-ga="whatsapp_click"],.qd-wa,.wa-inline'); if(a) ga('whatsapp_click',{link_url:a.href||''});
    var q=e.target.closest('.js-add-to-quote'); if(q) ga('quote_add',{item_sku:q.dataset.quoteSku||'',item_title:q.dataset.quoteTitle||''});
  },true);
  /* GA: primary CTA clicks (anchor buttons) + phone/email clicks outside distributor cards */
  document.addEventListener('click',function(e){
    var cta=e.target.closest('a.btn'); if(cta){var _sec=cta.closest('[id^="shopify-section-"]');ga('cta_click',{label:(cta.textContent||'').trim().slice(0,60),location:(_sec&&_sec.id)||location.pathname,link_url:cta.getAttribute('href')||''});}
    var tel=e.target.closest('a[href^="tel:"],a[href^="mailto:"]'); if(tel&&!e.target.closest('.dist-card')){var _h=tel.getAttribute('href')||'';ga('contact_click',{method:_h.indexOf('tel:')===0?'phone':'email',link_url:_h});}
  },true);
  /* GA: scroll-depth milestones */
  (function(){var marks=[25,50,75,100],hit={};function chk(){var d=document.documentElement,h=d.scrollHeight-d.clientHeight;if(h<=40)return;var p=((d.scrollTop||document.body.scrollTop)/h)*100,i;for(i=0;i<marks.length;i++){if(p>=marks[i]&&!hit[marks[i]]){hit[marks[i]]=1;ga('scroll_depth',{percent:marks[i]});}}}window.addEventListener('scroll',function(){requestAnimationFrame(chk);},{passive:true});})();
  /* GA: product_view + search (read a JSON meta the template renders) */
  try{var _pm=document.getElementById('productMeta');if(_pm){var _pd=JSON.parse(_pm.textContent);ga('product_view',{product:_pd.product,sku:_pd.sku,type:_pd.type});}}catch(e){}
  try{var _sm=document.getElementById('searchMeta');if(_sm){var _sd=JSON.parse(_sm.textContent);ga('search',{term:_sd.term,results_count:_sd.results_count});}}catch(e){}
  /* quote drawer: WhatsApp send button when number configured */
  if(cfg.wa){
    /* floating WhatsApp button: deep-link with a prefilled message that includes the current page title + URL */
    var waFloat=document.getElementById('waFloat');
    if(waFloat && !waFloat.classList.contains('wa-fallback')){
      var i18=window.themeI18n||{};
      var waPageLabel=i18.waPage||'Viewing';
      var waEmailLabel=i18.waEmail||'Email';
      var WA_EMAIL_RE=/^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      var WA_KEY='mp_wa_email';
      function waGetEmail(){try{return sessionStorage.getItem(WA_KEY)||''}catch(e){return ''}}
      function waSetEmail(v){try{sessionStorage.setItem(WA_KEY,v)}catch(e){}}
      /* message always carries the page they were on; email appended once captured */
      function waBuildUrl(email,q){
        var msg=cfg.waMsg+(q?'\n\n'+q:'')+'\n\n'+waPageLabel+': '+(document.title||'').trim()+'\n'+location.href;
        if(email){msg+='\n'+waEmailLabel+': '+email;}
        return 'https://wa.me/'+cfg.wa+'?text='+encodeURIComponent(msg);
      }
      function waOpen(email,q){
        /* temp-anchor click opens exactly one tab and keeps noopener — window.open('noopener')
           returns null on success, which used to trip a fallback and open a 2nd tab */
        var a=document.createElement('a');
        a.href=waBuildUrl(email,q); a.target='_blank'; a.rel='noopener';
        document.body.appendChild(a); a.click(); document.body.removeChild(a);
      }
      /* captured email is a lead: send to the portal even without cookie consent, GA only with consent */
      function waLead(email,ex){
        ex=ex||{};
        if(email) ga('whatsapp_lead',{page:location.pathname});
        /* Precedence: MontiWise forms.js is the authoritative lead-capture path. When it is
           active, the legacy portal bridge stands down so a submission is captured exactly once. */
        if(window.__mpFormsActive) return;
        if(!cfg.portal||!cfg.portalKey||!email) return;
        var payload={email:email,locale:(document.documentElement.lang||'en'),
          source:location.href,page_title:(document.title||'').trim(),
          form:'whatsapp',channel:'whatsapp',
          tags:['whatsapp','whatsapp-conversation-start','needs-whatsapp-reply'],
          status:'awaiting_whatsapp_reply',
          action_required:'Reply in the WhatsApp inbox — this contact opened a WhatsApp chat, not an email enquiry.',
          wa_number:cfg.wa,submitted_at:new Date().toISOString()};
        if(ex.country) payload.country=ex.country;
        if(ex.phone) payload.phone=ex.phone;
        if(ex.q||ex.phone){payload.fields={}; if(ex.q) payload.fields.Question=ex.q; if(ex.phone) payload.fields['WhatsApp (visitor)']=ex.phone;}
        try{fetch(cfg.portal+'?k='+encodeURIComponent(cfg.portalKey),{method:'POST',keepalive:true,
          headers:{'Content-Type':'application/json'},body:JSON.stringify(payload)}).catch(function(){});}catch(e){}
      }
      /* Country picker: value is the English name the portal's country routing rules use,
         label is in the page language. Pre-filled from the visitor's IP (inquiry-ack /geo). */
      var WA_CC_SKIP=/^(AC|AN|BU|CP|CQ|CS|DD|DG|EA|EU|EZ|FX|IC|QO|SU|TA|TP|UN|XA|XB|YD|YU|ZR|ZZ)$/;
      var WA_CC_FIX={TR:'Turkey',CI:'Ivory Coast',MM:'Myanmar',HK:'Hong Kong',MO:'Macau',CD:'Democratic Republic of the Congo',CG:'Congo',PS:'Palestine',VA:'Vatican City',KR:'South Korea',KP:'North Korea'};
      function waCountries(){
        try{
          var en=new Intl.DisplayNames(['en'],{type:'region',fallback:'none'}),
              loc=new Intl.DisplayNames([document.documentElement.lang||'en'],{type:'region',fallback:'none'}),
              A='ABCDEFGHIJKLMNOPQRSTUVWXYZ',out=[],i,j,c,n;
          for(i=0;i<26;i++)for(j=0;j<26;j++){c=A[i]+A[j]; if(WA_CC_SKIP.test(c)) continue; n=en.of(c); if(!n||n===c) continue;
            n=WA_CC_FIX[c]||n.replace(/ & /g,' and ').replace(/ SAR China$/,''); out.push({cc:c,en:n,label:loc.of(c)||n});}
          out.sort(function(a,b){return a.label.localeCompare(b.label);});
          return out;
        }catch(e){return null;}
      }
      var waGeo=null;
      function waFetchGeo(cb){
        if(waGeo!==null){cb(waGeo);return;}
        var ack=cfg.ackUrl||''; if(!ack){try{ack=JSON.parse(document.getElementById('hsConfig').textContent).ackUrl||'';}catch(e){}}
        if(!ack){waGeo='';cb('');return;}
        try{fetch(ack.replace(/\/$/,'')+'/geo').then(function(r){return r.json();}).then(function(j){waGeo=(j&&j.country)||'';cb(waGeo);}).catch(function(){waGeo='';cb('');});}catch(e){waGeo='';cb('');}
      }
      var waModal=null;
      function waGetModal(){
        if(waModal) return waModal;
        var wrap=document.createElement('div');
        wrap.className='wa-ask'; wrap.setAttribute('role','dialog'); wrap.setAttribute('aria-modal','true');
        wrap.setAttribute('aria-labelledby','waAskT'); wrap.hidden=true;
        var ph=(i18.waAskEmail||'Your email address').replace(/"/g,'&quot;');
        wrap.innerHTML='<div class="wa-ask-bd" data-wa-close></div>'+
          '<div class="wa-ask-card" role="document">'+
          '<button type="button" class="wa-ask-x" data-wa-close aria-label="Close">&times;</button>'+
          '<div class="wa-ask-ic"><svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor" aria-hidden="true"><path d="M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.64.07-.3-.15-1.26-.46-2.4-1.48-.88-.79-1.48-1.76-1.65-2.06-.17-.3-.02-.46.13-.6.13-.13.3-.35.44-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.5 0 1.47 1.07 2.89 1.22 3.09.15.2 2.1 3.2 5.08 4.49.71.3 1.26.49 1.7.63.71.22 1.36.19 1.87.12.57-.09 1.76-.72 2-1.42.25-.7.25-1.29.18-1.42-.07-.12-.27-.2-.57-.35zM12.05 21.79h-.01a9.87 9.87 0 01-5.03-1.38l-.36-.21-3.73.98 1-3.65-.24-.37a9.86 9.86 0 01-1.51-5.26c0-5.45 4.44-9.88 9.9-9.88a9.83 9.83 0 019.88 9.89c0 5.45-4.44 9.88-9.9 9.88zm8.42-18.3A11.82 11.82 0 0012.05 0C5.5 0 .16 5.34.16 11.9c0 2.1.55 4.14 1.59 5.94L.06 24l6.3-1.65a11.9 11.9 0 005.68 1.45c6.56 0 11.9-5.34 11.9-11.9 0-3.18-1.24-6.16-3.47-8.41z"/></svg></div>'+
          '<h3 id="waAskT">'+(i18.waAskTitle||'One quick thing')+'</h3>'+
          '<p>'+(i18.waAskSub||'')+'</p>'+
          '<form class="wa-ask-form" novalidate>'+
          '<input type="email" name="email" class="wa-ask-input" required autocomplete="email" inputmode="email" placeholder="'+ph+'" aria-label="'+ph+'">'+
          '<select name="country" class="wa-ask-input wa-ask-country" autocomplete="country-name" aria-label="'+(i18.waAskCountry||'Your country').replace(/"/g,'&quot;')+'"><option value="">'+(i18.waAskCountry||'Your country')+'</option></select>'+
          '<textarea name="message" class="wa-ask-input wa-ask-msg" rows="2" maxlength="600" placeholder="'+(i18.waAskMsg||'How can we help? (optional)').replace(/"/g,'&quot;')+'" aria-label="'+(i18.waAskMsgLbl||'Question').replace(/"/g,'&quot;')+'"></textarea>'+
          '<input type="tel" name="phone" class="wa-ask-input" autocomplete="tel" inputmode="tel" maxlength="30" placeholder="'+(i18.waAskPhone||'Your WhatsApp number (optional)').replace(/"/g,'&quot;')+'" aria-label="'+(i18.waAskPhone||'Your WhatsApp number (optional)').replace(/"/g,'&quot;')+'">'+
          /* hidden markers so any form-capture path (MontiWise tracker, HubSpot collected forms) tags this as a WhatsApp conversation, not a generic enquiry */
          '<input type="hidden" name="channel" value="whatsapp">'+
          '<input type="hidden" name="form" value="whatsapp">'+
          '<input type="hidden" name="enquiry_type" value="WhatsApp conversation">'+
          '<input type="hidden" name="wa_number" value="'+(cfg.wa||'')+'">'+
          '<input type="hidden" name="lead_note" value="Started a WhatsApp chat — reply in the WhatsApp inbox, not by email.">'+
          '<div class="wa-ask-err" role="alert" hidden></div>'+
          '<button type="submit" class="wa-ask-go">'+(i18.waAskBtn||'Continue to WhatsApp')+'</button>'+
          '</form>'+
          '<button type="button" class="wa-ask-skip" data-wa-skip>'+(i18.waAskSkip||'Skip')+'</button>'+
          '</div>';
        document.body.appendChild(wrap);
        var input=wrap.querySelector('.wa-ask-input');
        var err=wrap.querySelector('.wa-ask-err');
        var form=wrap.querySelector('.wa-ask-form');
        var sel=wrap.querySelector('.wa-ask-country'), msgEl=wrap.querySelector('.wa-ask-msg'), telEl=wrap.querySelector('input[name=phone]');
        var CL=waCountries();
        if(CL){ var byCc={}; CL.forEach(function(o){var op=document.createElement('option'); op.value=o.en; op.textContent=o.label; sel.appendChild(op); byCc[o.cc]=o.en;});
          waFetchGeo(function(cc){ if(cc&&byCc[cc]&&!sel.value) sel.value=byCc[cc]; }); }
        else { sel.parentNode.removeChild(sel); sel=null; } /* very old browser: no picker, lead lands in admin triage as before */
        function close(){wrap.hidden=true;document.removeEventListener('keydown',onKey);}
        function onKey(e){if(e.key==='Escape')close();}
        wrap.addEventListener('click',function(e){
          if(e.target.closest('[data-wa-close]')){close();return;}
          if(e.target.closest('[data-wa-skip]')){close();waOpen('');}
        });
        form.addEventListener('submit',function(e){
          e.preventDefault();
          var v=(input.value||'').trim();
          if(!WA_EMAIL_RE.test(v)){err.textContent=i18.waAskInvalid||'Please enter a valid email address.';err.hidden=false;input.focus();return;}
          var q=(msgEl&&msgEl.value||'').trim().slice(0,600), ph2=(telEl&&telEl.value||'').replace(/[^0-9+ ()-]/g,'').trim().slice(0,30);
          err.hidden=true; waSetEmail(v); waLead(v,{country:sel?sel.value:'',q:q,phone:ph2}); close(); waOpen(v,q);
        });
        waModal={open:function(){err.hidden=true;input.value=waGetEmail();wrap.hidden=false;document.addEventListener('keydown',onKey);setTimeout(function(){input.focus();},30);}};
        return waModal;
      }
      waFloat.setAttribute('data-ga','whatsapp_click');
      waFloat.href=waBuildUrl(''); waFloat.target='_blank'; waFloat.rel='noopener'; /* no-JS fallback */
      waFloat.addEventListener('click',function(e){
        e.preventDefault();
        var em=waGetEmail();
        if(em){waOpen(em);return;} /* already shared email this session — go straight through */
        waGetModal().open();
      });
    }
    var drawer=document.getElementById('quoteDrawer');
    if(drawer){
      var mo=new MutationObserver(function(){
        var foot=drawer.querySelector('.qd-actions')||drawer.querySelector('form')||drawer;
        if(foot && !drawer.querySelector('.qd-wa')){
          var a=document.createElement('a'); a.className='qd-wa'; a.target='_blank'; a.rel='noopener';
          a.innerHTML=(window.themeI18n&&window.themeI18n.sendWa)||'Send list via WhatsApp';
          a.addEventListener('click',function(){
            var items=[].slice.call(drawer.querySelectorAll('.qd-item')).map(function(it){
              var t=(it.querySelector('b')||{}).textContent||'', s=(it.querySelector('.qd-sku')||{}).textContent||'';
              var qn=(it.querySelector('.qd-q')||{}).textContent||'1';
              return '- '+t+(s?' ('+s+')':'')+' x'+qn;
            }).join('\n');
            a.href='https://wa.me/'+cfg.wa+'?text='+encodeURIComponent(cfg.waMsg+'\n\n'+((window.themeI18n&&window.themeI18n.waQuoteList)||'Quote list:')+'\n'+items+'\n\n'+((window.themeI18n&&window.themeI18n.waFrom)||'From:')+' '+location.href);
          });
          foot.appendChild(a);
        }
      });
      mo.observe(drawer,{childList:true,subtree:true});
    }
  }
  /* portal lead bridge: fire-and-forget beacon on lead form submits (never newsletter) */
  document.querySelectorAll('form[data-hs-form]').forEach(function(form){
    var kind=form.getAttribute('data-hs-form');
    form.addEventListener('focusin',function _mpfs(){form.removeEventListener('focusin',_mpfs);ga('form_start',{form_kind:kind});});
    form.addEventListener('submit',function(){
      if(form.dataset.mpBridged){return;} form.dataset.mpBridged='1'; // fire once — not again on the Shopify-fallback resubmit
      ga('form_submit',{form_kind:kind});
      /* R3: MontiWise forms.js is the authoritative browser capture path. When it is active it
         captures every data-hs-form submit (with full field + hidden-field allowlist support),
         so the legacy portal bridge stands down here to avoid a duplicate intake/notification.
         GA instrumentation above still runs. */
      if(window.__mpFormsActive) return;
      if(!cfg.portal||!cfg.portalKey||kind==='newsletter') return;
      var fd=new FormData(form), get=function(n){return fd.get('contact['+n+']')||fd.get(n)||''};
      var payload={name:get('name'),first_name:get('first_name'),last_name:get('last_name'),
        email:get('email'),phone:get('phone'),company:get('company'),website:get('website'),
        country:get('country'),enquiry_type:get('enquiry_type'),application:get('application'),
        product:get('product'),quote_items:get('quote_items'),help_topic:get('help_topic'),
        linkedin:get('linkedin'),message:get('body')||get('message'),
        locale:(document.documentElement.lang||'en'),source:location.href,form:kind,
        submitted_at:new Date().toISOString()};
      if(window.mpConsent&&window.mpConsent.allowed()){
        try{var _u=JSON.parse(localStorage.getItem('mp_utm')||'{}');Object.keys(_u).forEach(function(k){if(_u[k])payload[k]=_u[k];});}catch(e){}
        if(document.referrer)payload.referrer=document.referrer;
      }
      Object.keys(payload).forEach(function(k){if(payload[k]===''||payload[k]==null)delete payload[k];});
      try{
        fetch(cfg.portal+'?k='+encodeURIComponent(cfg.portalKey),{method:'POST',keepalive:true,
          headers:{'Content-Type':'application/json'},body:JSON.stringify(payload)}).catch(function(){});
      }catch(e){}
    });
  });
})();

/* global copy-link handler (js-share-copy-global) */
document.addEventListener('click',function(e){
  var b=e.target.closest('.js-share-copy'); if(!b||b.dataset.bound) return;
  var u=b.getAttribute('data-url');
  if(navigator.share&&/Mobi|Android/i.test(navigator.userAgent)){navigator.share({url:u}).catch(function(){});return}
  navigator.clipboard.writeText(u).then(function(){var t=b.querySelector('.sh-tip');if(t){t.hidden=false;setTimeout(function(){t.hidden=true},1600)}});
});

/* === intent instrumentation: pdf, video, calendar === */
(function(){
  function ga(ev,params){ if(window.mpTrack){window.mpTrack(ev,params);return;} if(!window.mpConsent||!window.mpConsent.allowed())return; try{ window.dataLayer=window.dataLayer||[]; window.dataLayer.push(Object.assign({event:ev},params||{})); }catch(e){} }
  document.addEventListener('click',function(e){
    var a=e.target.closest('a[href]');
    if(a){
      var h=a.getAttribute('href')||'';
      if(/\.pdf(\?|$)/i.test(h)){
        var f=h.split('?')[0].split('/').pop();
        ga('pdf_download',{file_name:decodeURIComponent(f),link_text:(a.textContent||'').trim().slice(0,80),page:location.pathname});
      } else if((h.indexOf('calendar.google.com')>-1 || h.indexOf('data:text/calendar')===0) && !window.__mpCampaign){
        ga('calendar_add',{page:location.pathname}); // campaign pages fire a richer calendar_add via campaign.js
      }
    }
    var v=e.target.closest('.mb-video-wrap,[data-video]');
    if(v){
      var url=v.getAttribute('data-video')||'';
      ga('video_play',{video_url:url,page:location.pathname});
    }
  },true);
})();

/* pre-launch: move focus to native form success/error region on load (fallback path) */
(function(){function f(){var el=document.querySelector('.nl-success[tabindex],.lf-success[tabindex],.askq-success[tabindex],.form-error[tabindex],.lf-error[tabindex],.nl-error[tabindex],.askq-error[tabindex]');if(el){try{el.focus();el.scrollIntoView({block:'center'});}catch(e){}}}if(document.readyState!=='loading'){f();}else{document.addEventListener('DOMContentLoaded',f);}})();

/* Insights article rail: table of contents built from the article's H2s */
(function(){
  var list=document.querySelector('[data-kb-toc]'); if(!list) return;
  var body=document.querySelector('.art-body .mp-post')||document.querySelector('.art-body');
  if(!body) return;
  var hs=[].slice.call(body.querySelectorAll('h2')).filter(function(h){return !h.closest('.mp-footnotes')&&h.textContent.trim();});
  if(hs.length<3) return;
  var links=hs.map(function(h,i){
    if(!h.id){h.id='s-'+(i+1)+'-'+h.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'').slice(0,40);}
    var li=document.createElement('li'),a=document.createElement('a');a.href='#'+h.id;a.textContent=h.textContent.trim();li.appendChild(a);list.appendChild(li);return a;
  });
  list.closest('.kb-toc').hidden=false;
  if(!('IntersectionObserver' in window)) return;
  var cur=null;
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){var i=hs.indexOf(e.target);if(cur)cur.classList.remove('on');cur=links[i];cur.classList.add('on');}});},{rootMargin:'-110px 0px -70% 0px'});
  hs.forEach(function(h){io.observe(h);});
})();
